import { render, staticRenderFns } from "./QCarrierPortalList.vue?vue&type=template&id=07885e05&scoped=true&"
import script from "./QCarrierPortalList.vue?vue&type=script&lang=js&"
export * from "./QCarrierPortalList.vue?vue&type=script&lang=js&"
import style0 from "./QCarrierPortalList.vue?vue&type=style&index=0&id=07885e05&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07885e05",
  null
  
)

export default component.exports